import React, { useEffect } from 'react';

import { useForm } from 'react-hook-form';
import { ContainerButton } from '../../../styles/global-style';
import { TextLarge, TextSmall } from '../../../components/text';
import { ModalTheme } from '../../../components/modal';
import { RenderForm } from '../../../components/forms';
import { ButtonTheme } from '../../../components/buttons';
import { openAlert } from '../../../components/alert/hooks';
import { FORM_TRACKING } from '../form';

export const UpdateTrackingModal = ({ open, onToggle, tableData, setTableData }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({});
  const { claimId, claimCode, fullName, trackingNumber } = tableData || {};

  const onSubmit = (values) => {
    setTableData((prevData) =>
      prevData.map((item) =>
        item.claimId === claimId ? { ...item, trackingNumber: values.trackingNumber } : item,
      ),
    );

    openAlert({ model: 'message', message: 'เปลี่ยนเลขพัสดุสำเร็จแล้ว' });
    onToggle({ defaultValue: '' });
  };

  useEffect(() => {
    setValue('trackingNumber', trackingNumber);
  }, [tableData, setValue]);

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <TextLarge text="แก้ไขเลขพัสดุ" />
      </div>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <TextSmall text={claimCode + ' ' + fullName} />
      </div>
      <RenderForm
        control={control}
        setValue={setValue}
        getValues={getValues}
        forms={FORM_TRACKING()}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
